module.exports = __webpack_public_path__ + "img/user-p.c6d303bb.svg";